import React, {Component} from 'react';
import { connect } from 'react-redux';
import updatePoster from 'controllers/poster/updatePoster'

import './TicketList.scss'

const mapStateToProps = (state) => ({
  user: state.user,
  posterDetail: state.posterDetail,
});


class OtherSettings extends Component{

  constructor(props){
    super(props)

    this.state = {
      show_spots_left: this.props.posterDetail.detail.show_spots_left == 1 ? 'yes' : 'no',
      show_page_view: this.props.posterDetail.detail.show_page_view == 1 ? 'yes' : 'no',
      posterId: this.props.posterDetail.detail.id,
    }
  }

  render(){
    const {show_spots_left, show_page_view, posterId} = this.state
    return(
      <div className='other-settings-content'>
        <p className='ticket-title'>{__('Other Settings', 'ticket')}</p>
        <p className='other-setting-title'>{__('Registration Progress', 'ticket')}</p>
        <input type='checkbox' checked={show_spots_left == 'yes'} onClick={() => {
          show_spots_left == 'yes' ?
          updatePoster(posterId, {show_spots_left: 'no'})
          .then((res) => { this.setState({show_spots_left: 'no'})}) :
          updatePoster(posterId, {show_spots_left: 'yes'})
          .then((res) => { this.setState({show_spots_left: 'yes'})})
        }} />
        <span className='other-setting-description'>{__('Show Registration Progress on Poster', 'ticket')}</span>

        <p className='other-setting-title'>{__('Read Count', 'ticket')}</p>
        <input type='checkbox' checked={show_page_view == 'yes'} onClick={() => {
          show_page_view == 'yes' ?
          updatePoster(posterId, {show_page_view: 'no'})
          .then((res) => {this.setState({show_page_view: 'no'})}) :
          updatePoster(posterId, {show_page_view: 'yes'})
          .then((res) => {this.setState({show_page_view: 'yes'})})
        }} />
        <span className='other-setting-description'>{__('Show Read Count on Poster', 'ticket')}</span>
      </div>
    )
  }
}


export default connect(mapStateToProps)(OtherSettings)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/OtherSettings.js